export const getApiBase = () => {
  if (typeof window !== "undefined" && window.location?.origin) {
    return window.location.origin;
  }

  return process.env.REACT_APP_BACKEND_URL;
};